import { FunctionalComponent } from 'vue'
import { HLoading } from '@nio-fe/horo-h5'
import styles from './styles.module.scss'

export type SpinProps = {
  spinning: boolean
  tip?: string
  style?: string
}

const Spin: FunctionalComponent<SpinProps> = (props) => {
  if (!props.spinning) {
    return null
  }
  return (
    <div style={props.style}>
      <div class={styles.spin}>
        <HLoading class="loading-item" type="brand" />
      </div>
      <div class={styles.desc}>{props.tip}</div>
    </div>
  )
}

Spin.displayName = 'Spin'

export default Spin
